module.exports = {"130804001":"鹰手营子矿区铁北路街道","130804100":"鹰手营子镇","130804101":"北马圈子镇","130804102":"寿王坟镇","130804103":"汪家庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130804.json
// module id = 202
// module chunks = 0